<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="invoiceErrorInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-radio-group
            label="Were errors in Customer Information / Pricing identified within 24 hours of IDOC / Order Confirmation receipt?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio
                name="errorsIdentifiedWithin24hours"
                formControlName="errorsIdentifiedWithin24hours"
                [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio
                name="errorsIdentifiedWithin24hours"
                formControlName="errorsIdentifiedWithin24hours"
                [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        @if(isTrue('errorsIdentifiedWithin24hours')) {
        <app-attachments-input
            label="Attach a copy of the communication to correct Information / Pricing"
            [form]="invoiceErrorInternationalForm!"
            [required]="true"
            controlName="communicationDocuments"
        ></app-attachments-input>
        } @if(isFalse('errorsIdentifiedWithin24hours')) {
        <sag-ui-radio-group
            label="Did the Invoice match the IDOC / Order Confirmation?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="invoiceMatchesIODC" formControlName="invoiceMatchesIODC" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="invoiceMatchesIODC" formControlName="invoiceMatchesIODC" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        }

        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-textarea
            [required]="true"
            label="Provide any additional information that will aid the Root Cause Investigation"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalInfo"
            class="max-w-input"
        ></sag-ui-textarea>
        <app-attachments-input [form]="invoiceErrorInternationalForm!" controlName="relatedDocuments" />
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
